<div class="wrapper bg-area" *ngIf="!isMobile">
  <section id="confirmacao">
    <div class="container area-faca-parte">
      <div class="header-faca-parte columns">
        <div class="column is-6" style="margin: 0px auto;">
          <div class="bar__container">
            <ul class="bar" id="bar">
              <li class="active active-step"><i class="fas fa-check"></i>Plano</li>
              <li class="active active-step"><i class="fas fa-check"></i>Dados Pessoais</li>
              <li class="active active-step"><i class="fas fa-check"></i>Pagamento</li>
              <li class="active active-step"><i class="fas fa-check"></i>Segurança</li>
              <li class="active active-step"><i class="fas fa-check"></i>Confirmação</li>
            </ul>
          </div>
        </div>
      </div>
      <form>
        <div class="body-faca-parte columns">
          <div class="column is-6" style="margin: 0px auto;">

            <div class="dados-pessoais">

              <div class="text-center">
                <img class="icon-montreal" src="assets/img/icon-sucesso-cadastro.png" />
                <h2>OBRIGADO!</h2>
              </div>
              <div class="text-center">
                <p>
                  Sua proposta já está sendo analisada!
                </p>
                <div class="atencao-container">
                  <h3><strong>ATENÇÃO:</strong></h3>
                  <p class="description">
                    Para sua segurança, pode ser que a gente precise de uma
                    <strong>confirmação de compra que será enviada via e-mail ou SMS.</strong>
                    Fique de olho em suas mensagens e até no SPAM. O link de confirmação expira em 24h, tá bem ?
                  </p>
                  <p class="description">
                    Caso sua proposta já seja aprovada sem a necessidade dessa confirmação,
                    enviaremos um e-mail com seu contrato em até 24h.
                  </p>

                </div>
                <br/>
                <p>
                  Enquanto suas informações estão sendo processadas, navegue em nosso site e conheça nossos hotéis parceiros.
                </p>
                <a routerLink="/" class="btn-verde">VOLTAR PARA O SITE</a>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </section>

  <div class="aviso">
    <div class="revise-dados">
      <h3>Olá, Pedro!</h3>
      <a href="" class="link-verde">Não sou o Pedro</a>
      <p>Identificamos pelo seu CPF que você já é um cliente Montreal. Para agilizar sua compra, revise os dadoes e
        confirme efetuando seu login.</p>

      <a href="" class="btn-verde">REVISAR E CONCLUIR</a>
      <a href="" class="link-verde">Preciso atualizar meu cadastro</a>
    </div>
  </div>

</div>
<div class="wrapper bg-area" *ngIf="isMobile">
  <section id="confirmacao-mobile">
    <div class="container area-faca-parte">
      <div class="header-faca-parte columns">
        <form>
          <div class="column is-6">
            <div class="dados-pessoais">
              <div class="text-center">
                <img class="icon-montreal" src="assets/img/icon-sucesso-cadastro.png" />
                <div class="title">
                  <h3>OBRIGADO!</h3>
                </div>
              </div>

              <p class="subtitle">
                Sua proposta já está sendo analisada!
              </p>
              <div class="atencao-container">
                <h3><strong>ATENÇÃO:</strong></h3>
                <br/>
                <p class="description">
                  Para sua segurança, pode ser que a gente precise de uma
                  <strong>confirmação de compra que será enviada via e-mail ou SMS.</strong>
                  Fique de olho em suas mensagens e até no SPAM. O link de confirmação expira em 24h, tá bem ?
                </p>
                <p class="description">
                  Caso sua proposta já seja aprovada sem a necessidade dessa confirmação,
                  enviaremos um e-mail com seu contrato em até 24h.
                </p>
              </div>
              <br/>
              <p>
                Enquanto suas informações estão sendo processadas, navegue em nosso site e conheça nossos hotéis parceiros.
              </p>
              <a routerLink="/" class="btn-verde">VOLTAR PARA O SITE</a>

            </div>
          </div>
        </form>
      </div>
    </div>
  </section>

  <div class="aviso">
    <div class="revise-dados">
      <h3>Olá, Pedro!</h3>
      <a href="" class="link-verde">Não sou o Pedro</a>
      <p>Identificamos pelo seu CPF que você já é um cliente Montreal. Para agilizar sua compra, revise os dados e
        confirme efetuando seu login.</p>

      <a href="" class="btn-verde">REVISAR E CONCLUIR</a>
      <a href="" class="link-verde">Preciso atualizar meu cadastro</a>
    </div>
  </div>

</div>
